import { render, staticRenderFns } from "./quotation-add-or-update.vue?vue&type=template&id=5fe96900&scoped=true"
import script from "./quotation-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotation-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./quotation-add-or-update.vue?vue&type=style&index=0&id=5fe96900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe96900",
  null
  
)

export default component.exports